export default __webpack_public_path__ + "static/media/serviceQuality.d2d096a7.png";